export const ROUTE_PAIRS = [
  { da: '/', en: '/en' },
  { da: '/produkter', en: '/en/products' },
  { da: '/om-os', en: '/en/about' },
  { da: '/centralsmoering', en: '/en/central-lubrication' },
  { da: '/coilanlaeg', en: '/en/coilanlaeg' },
  { da: '/coilanlaeg-og-foelgeudstyr', en: '/en/coilanlaeg' },
  { da: '/laser', en: '/en/laser' },
  { da: '/fiberlaser', en: '/en/fiberlaser' },
  { da: '/roerlaser', en: '/en/roerlaser' },
  { da: '/slibe-og-afgratemaskiner', en: '/en/slibe-og-afgratemaskiner' },
  { da: '/slibemaskiner', en: '/en/slibe-og-afgratemaskiner' },
  { da: '/pladeklipning', en: '/en/pladeklipning' },
  { da: '/saks', en: '/en/shears' },
  { da: '/panelbukker', en: '/en/panelbukker' },
  { da: '/hydraulisk-presse', en: '/en/hydraulisk-presse' },
  { da: '/kantpresse', en: '/en/press-brakes' },
  { da: '/kantpresser', en: '/en/press-brakes' },
  { da: '/kantbukker', en: '/en/press-brakes' },
  { da: '/mekanisk-presse', en: '/en/mekanisk-presse' },
  { da: '/presser', en: '/en/presses' },
  { da: '/styringer-og-software', en: '/en/styringer-og-software' },
  { da: '/udstyr', en: '/en/equipment' },
  { da: '/rettevaerk', en: '/en/coilanlaeg' },
  { da: '/presser-2', en: '/en/used-machines' },
  { da: '/brugte-maskiner', en: '/en/used-machines' },
  { da: '/reservedele', en: '/en/spare-parts' },
  { da: '/service', en: '/en/service' },
  { da: '/leverandoerer', en: '/en/suppliers' },
  { da: '/pmb-partnere', en: '/en/partners' },
  { da: '/samarbejdspartnere', en: '/en/partners' },
  { da: '/pmb-job-ledige-stillinger', en: '/en/jobs' },
  { da: '/kontakt', en: '/en/contact' },
  { da: '/pmb-salgs-leveringsbetingelser', en: '/en/terms-and-conditions' },
];

export const LEGACY_EN_ALIASES = {
  '/en/om-os': '/en/about',
  '/en/centralsmoering': '/en/central-lubrication',
  '/en/saks': '/en/shears',
  '/en/kantpresser': '/en/press-brakes',
  '/en/kantbukker': '/en/press-brakes',
  '/en/kantpresse': '/en/press-brakes',
  '/en/slibemaskiner': '/en/slibe-og-afgratemaskiner',
  '/en/grinding-machines': '/en/slibe-og-afgratemaskiner',
  '/en/pladeklipning': '/en/shears',
  '/en/shears': '/en/shears',
  '/en/udstyr': '/en/equipment',
  '/en/presser': '/en/presses',
  '/en/presser-2': '/en/used-presses',
  '/en/brugte-maskiner': '/en/used-machines',
  '/en/used-presses': '/en/used-machines',
  '/en/reservedele': '/en/spare-parts',
  '/en/leverandoerer': '/en/suppliers',
  '/en/pmb-partnere': '/en/partners',
  '/en/pmb-job-ledige-stillinger': '/en/jobs',
  '/en/kontakt': '/en/contact',
  '/en/pmb-salgs-leveringsbetingelser': '/en/terms-and-conditions',
};

const DOMAIN = 'https://pmborup.dk';

export function normalizePath(path) {
  if (!path) return '/';
  // Strip trailing slash unless it's root
  if (path.length > 1 && path.endsWith('/')) {
    return path.slice(0, -1);
  }
  return path;
}

export function isEnglishRoute(pathname) {
  const p = normalizePath(pathname);
  return p === '/en' || p.startsWith('/en/');
}

export function getEquivalentRoute(pathname, targetLang) {
  const norm = normalizePath(pathname);

  if (targetLang === 'en') {
    if (isEnglishRoute(norm)) return norm;
    const match = ROUTE_PAIRS.find((item) => item.da === norm);
    return match ? match.en : '/en';
  }

  // targetLang === 'da'
  if (!isEnglishRoute(norm)) return norm;
  const canonicalEn = LEGACY_EN_ALIASES[norm] || norm;
  const match = ROUTE_PAIRS.find((item) => item.en === canonicalEn);
  return match ? match.da : '/';
}

export function getCanonicalAndHreflang(pathname) {
  const norm = normalizePath(pathname);
  const isEn = isEnglishRoute(norm);

  let daPath = '/';
  let enPath = '/en';

  if (isEn) {
    const canonicalEn = LEGACY_EN_ALIASES[norm] || norm;
    enPath = canonicalEn;
    const match = ROUTE_PAIRS.find((item) => item.en === canonicalEn);
    daPath = match ? match.da : '/';
  } else {
    daPath = norm;
    const match = ROUTE_PAIRS.find((item) => item.da === norm);
    enPath = match ? match.en : '/en';
  }

  const currentPath = isEn ? enPath : daPath;

  return {
    lang: isEn ? 'en' : 'da',
    canonicalUrl: `${DOMAIN}${currentPath}`,
    hreflangDa: `${DOMAIN}${daPath}`,
    hreflangEn: `${DOMAIN}${enPath}`,
    hreflangDefault: `${DOMAIN}${daPath}`,
  };
}

export function getStoredLanguage() {
  try {
    return localStorage.getItem('pmb_language') || null;
  } catch {
    return null;
  }
}

export function setStoredLanguage(lang) {
  try {
    localStorage.setItem('pmb_language', lang);
  } catch {}
}
